<!--
 * @Author: fengxiaojing
 * @LastEditTime: 2022-05-09 16:38:46
 * @Description: 查看标记
 * @LastEditors: Please set LastEditors
-->
<template>
  <div class=" marker_detail position-absolute" v-drag>
    <el-card>
      <div slot="header">
        <span>查看标记</span>
        <span
          class="iconfont icon-close cur-pointer position-absolute close_icon"
          @click="closeDialog('end')"
        ></span>
      </div>
      <el-form label-position="right" label-width="80px" :model="markDatil">
        <el-form-item label="名称">
          <el-input v-model="markDatil.name" disabled></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input disabled type="textarea" v-model="markDatil.remark"> </el-input>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>
<script>
export default {
  props: {
    markDatil: {
      type: Object,
      default: {
        name: '',
        remark: '',
      },
    },
  },
  data() {
    return {}
  },
  created() {},
  methods: {
    closeDialog(val) {
      this.$emit('closeComponents', val)
    },
  },
  directives: {
    drag: {
      // 指令的定义
      bind(el) {
        const odiv = el // 获取当前元素
        el.onmousedown = (e) => {
          if (e.button === 0) {
            // 阻止穿透
            e.stopPropagation()
            // 算出鼠标相对元素的位置
            if (e.target.className === 'el-input__inner') {
              return
            }
            const disX = e.clientX - odiv.offsetLeft
            const disY = e.clientY - odiv.offsetTop
            let left = ''
            let top = ''
            document.onmousemove = (e) => {
              // 阻止穿透
              e.stopPropagation()
              // 用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
              left = e.clientX - disX
              top = e.clientY - disY
              // 绑定元素位置到positionX和positionY上面
              // 移动当前元素
              if (left < 0) {
                left = 0
              } else if (left > document.documentElement.clientWidth - odiv.offsetWidth) {
                left = document.documentElement.clientWidth - odiv.offsetWidth
              }
              if (top < 45) {
                top = 45
              } else if (top > document.documentElement.clientHeight - odiv.offsetHeight - 20) {
                top = document.documentElement.clientHeight - odiv.offsetHeight - 20
              }
              odiv.style.left = `${left}px`
              odiv.style.top = `${top}px`
            }
          }
          document.onmouseup = (e) => {
            document.onmousemove = null
            document.onmouseup = null
            document.onmouseout = null
          }
          return false
        }
      },
    },
  },
}
</script>
<style lang="scss" scoped>

.marker_detail {
  bottom: 3%;
  right: 3%;
  padding: 10px;
  height: 260px;
  width: 450px;
}
.close_icon {
  top: 26px;
  right: 26px;
}
/deep/ .el-card {
  &__body,
  &__header {
    background-color: #fff;
  }
  .el-card__body {
    padding: 20px;
  }
}

</style>
